import { useEffect, useState } from "react";
import SingleCourse from "../../../../MainComponents/SingleCourse";
import SingleChapter from "../../../../MainComponents/SingleChapter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useAuthState } from "../../../../MainComponents/GlobalContext.jsx";
import useAxios from "../../../../MainComponents/Hooks/useAxios.jsx";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import { Loader } from "../../../../MainComponents";
import SingleCourseCode from "../../../../MainComponents/SingleCourseCode.jsx";
import { useQueryState } from "nuqs";

function AdminCourses() {
  const navigate = useNavigate();
  const AuthState = useAuthState();
  const [reFetch, setReFetch] = useState(false);
  const [academicLevel, setAcademicLevel] = useQueryState("level", {
    defaultValue: "11",
  });

  const [allCoursesData, allCoursesErrors, allCoursesloading] = useAxios(
    process.env.REACT_APP_ADMIN_COURSES_API,
    "GET",
    "GET",
    reFetch
  );

  const filteredCourses = allCoursesData?.data?.filter((lecture) => {
    return +lecture.stage === +academicLevel;
  });

  return (
    <section
      className={`  h-auto  w-full  px-20 py-20  dark:bg-dark dark:text-light `}
    >
      <HelmetTags title="المحاضرات | مسيو بلال عبدالله "></HelmetTags>
      <div className="mb-32 flex flex-col items-end gap-20">
        <h2 className="w-full text-end text-4xl font-bold md:text-center">
          المحاضرات
        </h2>{" "}
        {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
          AuthState.userData?.admin?.permissions?.some((permission) =>
            permission.name.startsWith("lecture_add")
          )) && (
          <div className="flex w-full justify-end gap-10 md:flex-col md:justify-evenly">
            <button
              onClick={() => navigate("/admin/courses/add-course")}
              className="ml-4 md:w-full flex items-center justify-center rounded-xl border-2 border-secondary bg-secondary px-2 py-1 font-semibold text-light transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 "
            >
              <FontAwesomeIcon className="mr-4" icon={faPlus} />
              اضافة كورس شهري
            </button>
          </div>
        )}
      </div>
      <div className="flex w-full  pb-20 justify-end gap-10 md:justify-center md:flex-col-reverse sm:items-center">
        <button
          onClick={() => {
            setAcademicLevel("3");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "3" && "bg-secondary text-light"
          }`}
        >
          الصف الثالث الثانوي
        </button>

        <button
          onClick={() => {
            setAcademicLevel("2");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "2" && "bg-secondary text-light"
          }`}
        >
          الصف الثاني الثانوي
        </button>
        <button
          onClick={() => {
            setAcademicLevel("1");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "1" && "bg-secondary text-light"
          }`}
        >
          الصف الأول الثانوي
        </button>
        <button
          onClick={() => {
            setAcademicLevel("33");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "33" && "bg-secondary text-light"
          }`}
        >
          ثالثة الاعدادي
        </button>
        <button
          onClick={() => {
            setAcademicLevel("22");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "22" && "bg-secondary text-light"
          }`}
        >
          ثانية الاعدادي
        </button>
        <button
          onClick={() => {
            setAcademicLevel("11");
          }}
          className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
            academicLevel === "11" && "bg-secondary text-light"
          }`}
        >
          أولى الاعدادي
        </button>
      </div>
      {allCoursesloading ? (
        <Loader />
      ) : (
        <div className="courses grid-auto-fit">
          {allCoursesData?.data?.length === 0 ? (
            <p>لا يوجد كورسات</p>
          ) : (
            filteredCourses?.map((Card) => {
              return (
                <SingleCourseCode
                  reFetch={reFetch}
                  setReFetch={setReFetch}
                  admin
                  courseCode={Card}
                  key={Card.id}
                />
              );
            })
          )}
        </div>
      )}
    </section>
  );
}

export default AdminCourses;
